import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link, withRouter } from 'react-router-dom'
import styled, { css } from 'styled-components';
import { Context } from '../context';
import { Select } from './Select';


const EMOJIS = [
  {
    id: 'fire',
    emoji: '🔥',
  },
  {
    id: 'burger',
    emoji: '🍔',
  },
  {
    id: 'tennis',
    emoji: '🥎',
  },
  {
    id: 'puz',
    emoji: '🧩',
  },
  {
    id: 'magic',
    emoji: '✨',
  },
  {
    id: 'mush',
    emoji: '🍄',
  },
  {
    id: 'clover',
    emoji: '🍀',
  },
  {
    id: 'crown',
    emoji: '👑',
  },
  {
    id: 'hat',
    emoji: '🎩',
  },
  {
    id: 'aid',
    emoji: '⛑',
  },
]

export function UIemojiSelect({ active = 'fire', handleChange }) {
  const context = useContext(Context);


  const [activeEmoji, setActiveEmoji] = useState(active)

  handleChange = handleChange ? handleChange : setActiveEmoji;
  return (
    <>

      <Select
        dropIcon={false}
        style={{
          fontSize: 20
        }}
        dropStyle={{
          display: "flex",
          // flexDirection: "column",
          flexDirection: "row",
          flexWrap: "wrap",
          width: 340,
          justifySelf: "stretch",
          borderRadius: "0.2em",
          // padding: "0.4em 0.6em",
        }}
        dropItemStyle={{
          fontSize: 20,
          borderRadius: "0.2em",
          padding: "0.4em 1em",
          margin: "0.2em",
          minHeight: 32,
        }}
        // colors={{ ...selectColors }}
        // handleReset={
        //   Boolean(filter.length) ? () => resetFilter("color") : false
        // }
        multiSelect={false}
        width={36}
        // size="sm"
        placeholder="🏁"
        active={activeEmoji}
        // customTrigger={
        //   <>
        //     <div className="x_team0"
        //       style={{
        //         position: 'absolute',
        //       }}
        //     >
        //       <div className="x_team_hover"
        //       // style={{ backgroundColor: 'transparent' }}
        //       >
        //         <div className="ico">
        //           <div>arrow_drop_down</div>
        //         </div>
        //       </div>
        //       <div className="x_team_logo">
        //         <div className="x_prj_icon x_prj_icon--pers">
        //           <div>P</div>
        //         </div>
        //         <div className="l_c_menu_info_h">
        //           <div>Personal space</div>
        //         </div>
        //       </div>
        //     </div>
        //   </>
        // }
        // activeCustom={
        //   <div className="x_team_logo">
        //     <div className="x_prj_icon"
        //       style={{
        //         backgroundColor: getDataByUniq(context, 'spaces', match.params['space'], 'color'),
        //       }}
        //     >
        //       {getDataByUniq(context, 'spaces', match.params['space'], 'titleShort')}
        //     </div>
        //     <div className="l_c_menu_info_h">
        //       {getDataByUniq(context, 'spaces', match.params['space'], 'title')}
        //     </div>
        //   </div>
        // }
        menuHandler={(val) => {
          handleChange(val)
        }}
        options={[
          ...EMOJIS.map(emojiData => ({
            title: emojiData['emoji'],
            value: emojiData['id'],
          }))
        ]}
      />


    </>
  )
}